import { getGlobalStore } from '@/lib/global-store';
const vuexStore = getGlobalStore();
const defaultMapId = 'delivery-charge-area-control-map';
export default class DeliveryChargeAreaControlMap {
    naver;
    mapInstance;
    mapId;
    options;
    hubCoordinate;
    center;
    polygonList;
    mousemoveListener;
    createAreaListenerList;
    isCreatePolygonAvailable;
    closeButtonInfo;
    tooltip;
    homeBtnHtml;
    constructor(options, mapId = defaultMapId) {
        this.naver = null;
        this.mapInstance = null;
        this.mapId = mapId;
        this.options = options;
        this.hubCoordinate = options.coordinate;
        this.center = null;
        this.polygonList = {};
        this.mousemoveListener = null;
        this.createAreaListenerList = null;
        this.isCreatePolygonAvailable = false;
        this.closeButtonInfo = {
            isVisible: false,
            areaId: '',
        };
        this.tooltip = {
            isVisible: false,
            position: {
                x: 0,
                y: 0,
            },
        };
        this.homeBtnHtml = `<div style="text-align:center">
    <span title="지도 중심 초기화" style="cursor:pointer; display:inline-block;background:#fff;
    border:1px solid #000;border-radius:5px;width:30px;height:30px">
    <img style="margin-top:5px" src="/svg/flag.svg" />
    </span></div>`;
    }
    init() {
        if (!document.querySelector(`#${defaultMapId}`)) {
            return;
        }
        // @ts-ignore
        vuexStore.dispatch('deliveryChargeAreaControl/resetStore');
        // @ts-ignore
        this.naver = window.naver;
        const { latitude, longitude } = this.hubCoordinate;
        this.center = new this.naver.maps.LatLng(latitude, longitude);
        this.options = {
            center: this.center,
            maxZoom: 19, // 20km
            minZoom: 6, // 100km
            zoom: 14, // 500m
            mapDataControl: false,
            logoControl: false,
            logoControlOptions: {
                position: this.naver.maps.Position.BOTTOM_LEFT,
            },
            scaleControl: true,
            scaleControlOptions: {
                position: this.naver.maps.Position.BOTTOM_LEFT,
            },
            zoomControl: true,
            zoomControlOptions: {
                position: this.naver.maps.Position.RIGHT_BOTTOM,
            },
            ...this.options,
        };
        this.mapInstance = new this.naver.maps.Map(this.mapId, {
            ...this.options,
        });
        this.polygonList = {};
        this.mousemoveListener = null;
        this.createAreaListenerList = null;
        this.isCreatePolygonAvailable = false;
        this.initHomeBtn();
    }
    /**
     * 홈버튼 셋팅
     */
    initHomeBtn() {
        const customControl = new this.naver.maps.CustomControl(this.homeBtnHtml, {
            position: this.naver.maps.Position.RIGHT_BOTTOM,
        });
        this.naver.maps.Event.once(this.mapInstance, 'init', () => {
            customControl.setMap(this.mapInstance);
            this.naver.maps.Event.addDOMListener(customControl.getElement(), 'click', () => {
                this.mapInstance.setCenter(this.center);
            });
        });
    }
    /**
     * 폴리곤 셋팅
     * @param isCreateAreaMode
     * @param item
     */
    setPolygon(isCreateAreaMode, item) {
        const areaId = isCreateAreaMode
            // 최초 그릴 때 폴리곤 아이디 temp
            ? 'temp'
            : item?.areaId;
        const polygonPath = [
            [],
        ];
        this.polygonList[areaId] = new this.naver.maps.Polygon({
            areaId,
            fillColor: '#1e88e5',
            fillOpacity: 0.1,
            strokeColor: '#1e88e5',
            strokeOpacity: 1,
            strokeWeight: 2,
            paths: polygonPath,
            map: this.mapInstance,
            clickable: !isCreateAreaMode,
        });
        if (!isCreateAreaMode) {
            item.registeredPath
                .forEach(({ latitude, longitude }) => this.polygonList[areaId].getPath()
                .push(new this.naver.maps.LatLng(latitude, longitude)));
        }
        /**
         * 선택한 구역에 마우스 오버시 핸들러
         */
        this.naver.maps.Event.addListener(this.polygonList[areaId], 'mouseover', (event) => {
            if (areaId === 'temp') {
                return;
            }
            this.polygonList[areaId].setOptions({
                fillOpacity: 0.2,
                strokeWeight: 4,
            });
            const isBoundaryList = false;
            // @ts-ignore
            vuexStore.dispatch('deliveryChargeAreaControl/setSelectedArea', {
                isBoundaryList,
                areaId,
            });
            this.tooltip = {
                isVisible: true,
                position: {
                    x: event.originalEvent.pageX,
                    y: event.originalEvent.pageY,
                },
            };
        });
        /**
         * 선택한 구역에 마우스아웃시 핸들러
         */
        this.naver.maps.Event.addListener(this.polygonList[areaId], 'mouseout', () => {
            if (areaId === 'temp') {
                return;
            }
            this.polygonList[areaId].setOptions({
                fillOpacity: 0.1,
                strokeWeight: 2,
            });
            this.resetTooltipInfo();
        });
        // 구역 추가시에는 이벤트 핸들러 추가
        if (isCreateAreaMode) {
            const clickEventLister = this.naver.maps.Event.addListener(this.mapInstance, 'click', (event) => {
                const getterIsCreateAreaMode = vuexStore.getters['deliveryChargeAreaControl/getterIsCreateAreaMode'];
                if (!getterIsCreateAreaMode) {
                    return;
                }
                if (!this.isCreatePolygonAvailable) {
                    const isDelete = false;
                    this.resetPolygon(isDelete, areaId);
                    this.isCreatePolygonAvailable = true;
                }
                const isVisible = this.polygonList[areaId].getVisible();
                if (!isVisible) {
                    this.polygonList[areaId].setVisible(true);
                    this.polygonList[areaId].setPaths([
                        [],
                    ]);
                }
                const currentPolygonPath = this.polygonList[areaId].getPath();
                currentPolygonPath.push(event.coord);
                const pathList = currentPolygonPath._array.map(({ _lat, _lng }) => JSON.stringify({
                    latitude: _lat,
                    longitude: _lng,
                }));
                const coordinateSet = Array.from(new Set(pathList)).map((pathString) => JSON.parse(pathString));
                // @ts-ignore
                vuexStore.dispatch('deliveryChargeAreaControl/setCurrentPolygonCoordinateList', coordinateSet);
                if (!this.mousemoveListener) {
                    this.mousemoveListener = this.naver.maps.Event
                        .addListener(this.mapInstance, 'mousemove', (_event) => this.setGuideAreaPath(_event.originalEvent, areaId));
                }
            });
            /**
             * 우클릭 이벤트
             */
            const rightClickEventListener = this.naver.maps.Event.addListener(this.mapInstance, 'rightclick', (event) => {
                const getterIsCreateAreaMode = vuexStore.getters['deliveryChargeAreaControl/getterIsCreateAreaMode'];
                if (!getterIsCreateAreaMode) {
                    return;
                }
                if (!this.isCreatePolygonAvailable) {
                    return;
                }
                const currentPolygonPath = this.polygonList[areaId].getPath();
                currentPolygonPath.push(event.coord);
                const pathList = currentPolygonPath._array.map(({ _lat, _lng }) => JSON.stringify({
                    latitude: _lat,
                    longitude: _lng,
                }));
                const coordinateSet = Array.from(new Set(pathList)).map((pathString) => JSON.parse(pathString));
                // @ts-ignore
                vuexStore.dispatch('deliveryChargeAreaControl/setCurrentPolygonCoordinateList', coordinateSet);
                // 이벤트 제거
                this.naver.maps.Event.removeListener(this.mousemoveListener);
                this.mousemoveListener = null;
                this.isCreatePolygonAvailable = false;
            });
            this.createAreaListenerList = [
                clickEventLister,
                rightClickEventListener,
            ];
            // 구역설정 추가 버튼 클릭 후 1초 뒤 폴리곤 그리기를 시작한다
            setTimeout(() => {
                this.isCreatePolygonAvailable = true;
            }, 1000);
        }
    }
    setGuideAreaPath(event, areaId) {
        const projection = this.mapInstance.getProjection();
        const coord = projection.fromPageXYToCoord(new this.naver.maps.Point(event.pageX, event.pageY));
        const currentPolygonPath = this.polygonList[areaId].getPath();
        if (currentPolygonPath.getLength() >= 2) {
            currentPolygonPath.pop();
        }
        currentPolygonPath.push(coord);
    }
    setEupMyeonDongPolygon(areaId) {
        const getterEupMyeonDongBoundaryCurrentInfo = vuexStore.getters['deliveryChargeAreaControl/getterEupMyeonDongBoundaryCurrentInfo'];
        const polygonPath = [
            getterEupMyeonDongBoundaryCurrentInfo[areaId]
                .coordinateList
                .map(({ latitude, longitude }) => (new this.naver.maps.LatLng(latitude, longitude))),
        ];
        this.polygonList[areaId] = new this.naver.maps.Polygon({
            fillColor: '#ff0000',
            fillOpacity: 0,
            strokeColor: '#ff0000',
            strokeOpacity: 0.5,
            strokeWeight: 2,
            paths: polygonPath,
            map: this.mapInstance,
            clickable: true,
        });
        const isVisible = true;
        // @ts-ignore
        vuexStore.dispatch('deliveryChargeAreaControl/setEupMyeonDongBoundaryVisibleList', {
            isVisible,
            areaId,
        });
        this.naver.maps.Event.addListener(this.polygonList[areaId], 'mouseover', (event) => {
            const isBoundaryList = true;
            // @ts-ignore
            vuexStore.dispatch('deliveryChargeAreaControl/setSelectedArea', {
                isBoundaryList,
                areaId,
            });
            this.polygonList[areaId].setOptions({
                fillOpacity: 0.2,
                strokeWeight: 4,
            });
            const { pageX, pageY } = event.originalEvent;
            this.tooltip = {
                isVisible: true,
                position: {
                    x: pageX,
                    y: pageY,
                },
            };
        });
        this.naver.maps.Event.addListener(this.polygonList[areaId], 'mouseout', () => {
            this.polygonList[areaId].setOptions({
                fillOpacity: 0,
                strokeWeight: 2,
            });
            this.resetTooltipVisible();
        });
    }
    resetTooltipInfo() {
        this.tooltip = {
            isVisible: false,
            position: {
                x: 0,
                y: 0,
            },
        };
    }
    resetTooltipVisible() {
        this.tooltip.isVisible = false;
    }
    resetCloseButtonInfo() {
        this.closeButtonInfo = {
            isVisible: false,
            areaId: '',
        };
        this.resetTooltipInfo();
    }
    setPolygonClickableDisabled(isCreateAreaMode, areaIdList) {
        const color = isCreateAreaMode ? '#757575' : '#1e88e5';
        areaIdList.forEach((areaId) => {
            this.polygonList[areaId]?.setOptions({
                fillColor: color,
                strokeColor: color,
            });
            const isClickable = !isCreateAreaMode;
            this.setPolygonClickable(areaId, isClickable);
        });
    }
    setEupMyeonDongBoundaryPolygonClickableDisabled(isCreateAreaMode, areaIdList) {
        areaIdList.forEach((areaId) => {
            const isClickable = !isCreateAreaMode;
            this.setPolygonClickable(areaId, isClickable);
        });
    }
    setPolygonClickable(areaId, isClickable) {
        this.polygonList[areaId]?.setClickable(isClickable);
    }
    /**
     * 구역명으로 그린 폴리곤 전체 삭제
     * @param exceptDongPolygon 동경계추가로 그려진 폴리곤 제외
     */
    destroyAllPolygon(exceptDongPolygon = false) {
        Object.values(this.polygonList).forEach((polygon) => {
            const { areaId } = polygon;
            // 동경계제외일 경우 areaId 없는 것 (동경계) 추가된 것은 제외
            if (exceptDongPolygon && !areaId) {
                return;
            }
            delete this.polygonList[areaId];
            this.naver.maps.Event.removeListener(this.createAreaListenerList);
            polygon.setMap(null);
        });
        // 삭제 케이스
        // this.polygonList[areaId]?.setMap(null);
        // delete this.polygonList[areaId];
        this.naver.maps.Event.removeListener(this.createAreaListenerList);
        if (this.mousemoveListener) {
            this.naver.maps.Event.removeListener(this.mousemoveListener);
            this.mousemoveListener = null;
        }
        // @ts-ignore
        vuexStore.dispatch('deliveryChargeAreaControl/setCurrentPolygonCoordinateList', []);
    }
    /**
     * 폴리곤 리셋
     * @param isDelete
     * @param areaId
     */
    resetPolygon(isDelete, areaId) {
        // 삭제 케이스
        if (isDelete) {
            this.polygonList[areaId]?.setMap(null);
            delete this.polygonList[areaId];
            this.naver.maps.Event.removeListener(this.createAreaListenerList);
            if (this.mousemoveListener) {
                this.naver.maps.Event.removeListener(this.mousemoveListener);
                this.mousemoveListener = null;
            }
            // @ts-ignore
            vuexStore.dispatch('deliveryChargeAreaControl/setCurrentPolygonCoordinateList', []);
        }
        else {
            this.polygonList[areaId]?.setVisible(false);
        }
    }
    setEupMyeonDongPolygonVisible(isVisible, areaId) {
        this.polygonList[areaId].setVisible(isVisible);
        this.resetCloseButtonInfo();
        // @ts-ignore
        vuexStore.dispatch('deliveryChargeAreaControl/setEupMyeonDongBoundaryVisibleList', {
            isVisible,
            areaId,
        });
    }
    setOptions(coordinate) {
        const { zoom } = this.options;
        this.hubCoordinate = coordinate;
        const { latitude, longitude } = this.hubCoordinate;
        this.center = new this.naver.maps.LatLng(latitude, longitude);
        this.mapInstance.updateBy(this.center, zoom);
    }
    destroy() {
        if (this.polygonList.temp) {
            this.polygonList.temp.setMap(null);
        }
        this.mapInstance.destroy();
    }
}
